import { itemFields } from 'src/enums/time-tracker';
import { getColumnAlignments } from 'src/common/table/column-utils';
import { getFields, TTimeTrackerField } from './get-tt-fields';

const columnAlignment: Partial<Record<TTimeTrackerField, 'left' | 'right'>> = {
  [itemFields.START]: 'left',
  [itemFields.NAME]: 'left',
  [itemFields.AFE]: 'right',
  [itemFields.ESTIMATE]: 'right',
  [itemFields.P90]: 'right',
  [itemFields.ACTUAL]: 'right',
  [itemFields.NPT]: 'right',
  [itemFields.WOW]: 'right',
  [itemFields.VARIANCE]: 'right',
  [itemFields.FINISH]: 'left',
  [itemFields.ACTUAL_DEPTH]: 'right',
  [itemFields.PLANNED_DEPTH]: 'right',
  [itemFields.ACTIVITY]: 'left',
  [itemFields.OPERATION]: 'left',
  [itemFields.SECTION]: 'left',
};

export const getColumnAlignment = (disabledFields: string[] = []) => {
  const fields = getFields(disabledFields);
  return getColumnAlignments(fields, columnAlignment);
};
